// Client logos and user avatars arrive as a URL or as raw Base64 (legacy).
export const getImageSrc = image => {
  if (!image) return undefined
  if (/^(https?:)?\/\//.test(image) || image.startsWith('/') || image.startsWith('data:')) return image

  return `data:image/png;base64,${image}`
}
